import React from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import BlockIcon from "@mui/icons-material/Block";
import {
  dialogPaper,
  dialogContent,
  contentBox,
  iconBox,
  messageText,
  dialogActions,
  cancelButton,
  confirmButton,
  iconStyles,
} from "./styles";

const ConfirmationDialog = ({
  open,
  onClose,
  onConfirm,
  title,
  message,
  confirmText = "Confirm",
  cancelText = "Cancel",
  confirmColor = "primary",
  icon = "warning",
}) => {
  const getIcon = () => {
    switch (icon) {
      case "clone":
        return <ContentCopyIcon sx={iconStyles} />;
      case "status":
        return <BlockIcon sx={iconStyles} />;
      case "warning":
      default:
        return <WarningAmberIcon sx={iconStyles} />;
    }
  };

  const getIconBackgroundColor = () => {
    switch (icon) {
      case "clone":
        return "#367598";
      case "status":
        return "#d32f2f";
      case "warning":
      default:
        return "#d32f2f";
    }
  };

  const getConfirmButtonColor = () => {
    switch (confirmColor) {
      case "warning":
        return "#f59e0b";
      case "error":
      case "danger":
        return "#d32f2f";
      case "success":
        return "#10b981";
      case "primary":
      default:
        return "#367598";
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      PaperProps={{
        sx: dialogPaper,
      }}
    >
      <DialogContent sx={dialogContent}>
        <Box sx={contentBox}>
          <Box
            sx={{
              ...iconBox,
              backgroundColor: getIconBackgroundColor(),
            }}
          >
            {getIcon()}
          </Box>
          <Typography sx={messageText}>{message}</Typography>
        </Box>
      </DialogContent>

      <DialogActions disableSpacing sx={dialogActions}>
        <Button variant="outlined" onClick={onClose} sx={cancelButton}>
          {cancelText}
        </Button>
        <Button
          variant="contained"
          onClick={onConfirm}
          sx={confirmButton(getConfirmButtonColor())}
        >
          {confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationDialog;
